export const propertyResaleReducer = (
    state = {
        propertyResaleList: null,
        propertyResaleDetail: null,
        resaleInterestedPropertyList: null,
        loading: false,
        listLoading: false,
        error: null,
    },
    action
) => {
    switch (action.type) {

        // ========== LIST ==========
        case "LIST_PROPERTY_RESALE_REQUEST":
            return { ...state, listLoading: true, error: null };
        case "LIST_PROPERTY_RESALE_SUCCESS":
            return {
                ...state,
                listLoading: false,
                propertyResaleList: action.payload,
                error: null,
            };
        case "LIST_PROPERTY_RESALE_FAILED":
            return { ...state, listLoading: false, error: action.payload };

        // ========== VIEW ==========
        case "VIEW_PROPERTY_RESALE_REQUEST":
            return { ...state, loading: true, error: null };
        case "VIEW_PROPERTY_RESALE_SUCCESS":
            return {
                ...state,
                loading: false,
                propertyResaleDetail: action.payload,
                error: null,
            };
        case "VIEW_PROPERTY_RESALE_FAILED":
            return { ...state, loading: false, error: action.payload };

        // ========== STATUS ==========
        case "STATUS_PROPERTY_RESALE_REQUEST":
            return { ...state, loading: true, error: null };
        case "STATUS_PROPERTY_RESALE_SUCCESS":
            return { ...state, loading: false, error: null };
        case "STATUS_PROPERTY_RESALE_FAILED":
            return { ...state, loading: false, error: action.payload };


        case "ADD_ADMIN_MARGIN_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "ADD_ADMIN_MARGIN_SUCCESS":
            return {
                ...state,
                loading: false,
                adminMarginAdded: true,
            };
        case "ADD_ADMIN_MARGIN_FAILED":
            return {
                ...state,
                loading: false,
                adminMarginError: action.payload,
            };

        case "UPDATE_ADMIN_MARGIN_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "UPDATE_ADMIN_MARGIN_SUCCESS":
            return {
                ...state,
                loading: false,
                adminMarginUpdated: true,
            };
        case "UPDATE_ADMIN_MARGIN_FAILED":
            return {
                ...state,
                loading: false,
                adminMarginError: action.payload,
            };


        case "GET_MARGIN_HISTORY_REQUEST":
            return {
                ...state,
                loading: true
            };

        case "GET_MARGIN_HISTORY_SUCCESS":
            return {
                ...state,
                loading: false,
                marginHistory: action.payload.data
            };

        case "GET_MARGIN_HISTORY_FAILED":
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case "LIST_RESALE_INTERESTED_PROPERTY_REQUEST":
            return { ...state, listLoading: true, error: null };
        case "LIST_RESALE_INTERESTED_PROPERTY_SUCCESS":
            return {
                ...state,
                listLoading: false,
                resaleInterestedPropertyList: action.payload,
                error: null,
            };
        case "LIST_RESALE_INTERESTED_PROPERTY_FAILED":
            return { ...state, listLoading: false, error: action.payload };

        case "UPDATE_STATUS_RESALE_INTERESTED_PROPERTY_REQUEST":
            return { ...state, loading: true, error: null };
        case "UPDATE_STATUS_RESALE_INTERESTED_PROPERTY_SUCCESS":
            return { ...state, loading: false, error: null };
        case "UPDATE_STATUS_RESALE_INTERESTED_PROPERTY_FAILED":
            return { ...state, loading: false, error: action.payload };

        // ========== STOP LOADING ==========
        case "STOP_LOADING":
            return { ...state, loading: false, listLoading: false };

        default:
            return state;
    }
};